import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store'; // 确保导入 store
import './theme/black/index.css';
import ElementUI from 'element-ui';
import { Message } from 'element-ui';
import elDragDialog from './utils/el-drag-dialog.js';
import { init } from '@/lib/init';
import { initSentry } from '@/lib/sentry';
// import * as Sentry from '@sentry/vue';
import { i18n } from '@/locales';
import { deviceDetect } from '@/utils/device-detect';

import './lib/cookie-consent.js';
import '../styles/index.css';

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
Vue.prototype.$baseMessage = (message, type) => {
  Message({
    message: message,
    type: type,
  });
};

Vue.directive('el-drag-dialog', elDragDialog); //添加标签事件绑定 可以放大移动弹窗

init()
  .then((auth) => {
    const isSaas = store.getters['common/isSaas'];

    if (isSaas) {
      initSentry();
    }

    Vue.mixin({
      data() {
        return {
          isMobile: deviceDetect().isMobile,
          APP_TITLE: process.env.VUE_APP_TITLE,
          EXTENSION_NAME: process.env.VUE_APP_EXTENSION_NAME,
          SUPPORT_EMAIL: process.env.VUE_APP_SUPPORT_EMAIL,
          DISCORD_URL: process.env.VUE_APP_DISCORD_URL,
          HOME_URL: process.env.VUE_APP_HOME_URL,
          BLOG_URL: process.env.VUE_APP_BLOG_URL,
        };
      },
    });

    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      render: (h) => h(App),
    });

    Vue.prototype.$auth = auth;
  })
  .catch((err) => {
    console.error(err);
  });
